import MainLayout from "../../layout/MainLayout";
import { DownloadOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import FilterSection from "../../components/FilterSection";
import useExpiredToken from "../../utils/useExpiredToken";
import { actionPost } from "../../services/api";
import { useSelector } from "react-redux";
import { Button } from "antd";
import moment from "moment";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import { filterDataFunc } from "../../constant";
import { useNavigate } from "react-router-dom";
import SelectAuditType from "../../components/models/SelectAuditType";
import DataTable from "../../common/Tables/DataTable";
import { useToast } from "../../utils/Toast";

const CompleteCalls = () => {
  const [qaList, setQAList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isAuditTypeModalOpen, setIsAuditTypeModalOpen] = useState(false);

  const expireToken = useExpiredToken();
  const token = useSelector((state) => state.auth.jwtToken);
  const { searchText } = useSelector((state) => state.search);
  const navigate = useNavigate();
    const toast = useToast();
  const mappedData = qaList.map((item, i) => ({
    key: item?.id,
    "Agent name": item?.agent_name || null,
    "Call type": item?.call_type || null,
    "Review date": moment(item?.created_at).format("MMMM Do YYYY") || null,
    "Call duration": item?.duration || null,
    "QA Comments Summary": item?.callObservation || null,
    Action: "View",
    // originalItem: item,
  }));

 const handleDownloadRecording = async (record) => {
    try {
      const callId = record?.originalItem?.id || record?.key;
      if (!callId) {
        toast.error("Invalid call ID");
        return;
      }
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/call-audits/${callId}/download`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to download recording");
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `call-recording-${record?.["Agent name"] || "agent"}.ogg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success("Recording downloaded");
    } catch (err) {
      toast.error("Cannot download recording: " + err.message);
    }
  };

  const filteredData = filterDataFunc(mappedData, searchText);

  const updatedColumns = [
    {
      title: "Agent name",
      dataIndex: "Agent name",
      key: "Agent name",
    },
    {
      title: "Call type",
      dataIndex: "Call type",
      key: "Call type",
      // filters: [
      //   { text: "Outgoing", value: "Outgoing" },
      //   { text: "Incoming", value: "Incoming" },
      // ],
      // onFilter: (value, record) => value && record["Call type"] === value,
    },
    {
      title: "Review date",
      dataIndex: "Review date",
      key: "Review date",
    },
    {
      title: "Call duration",
      dataIndex: "Call duration",
      key: "Call duration",
    },
    {
      title: "QA Comments Summary",
      dataIndex: "QA Comments Summary",
      key: "QA Comments Summary",
    },
    {
      title: "Download Recording",
      key: "recording_download",
      width: 170,
      render: (_, record) => (
        <Button
          icon={<DownloadOutlined />}
          size="small"
          style={{
            backgroundColor: "#ffffff",   // slightly different shade from report
            color: "#0d3b66",
            border: "1px solid #c7cbcf",
            height: "30px",
            padding: "8px 20px",
            fontWeight: 500,
            borderRadius: "6px",
          }}
          onClick={() => handleDownloadRecording(record)}
        >
          Recording
        </Button>
      ),
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      render: (_, record) => (
        <Button
          icon={<DownloadOutlined />}
          // onClick={() => {
          //   const width = window.screen.availWidth;
          //   const height = window.screen.availHeight;

          //   window.open(
          //     `/report-pdf?callId=${record.id}&auditTypeId=1`,
          //     "_blank",
          //     `width=${width},height=${height},left=0,top=0`
          //   );
          // }}
          onClick={() => {
            setSelectedRow(record);
            setIsAuditTypeModalOpen(true);
          }}
        >
          View Report
        </Button>
      ),
    },
  ];

  // const fetchCompleteCall = async () => {
  //   const res = await actionPost("calls/summary", token, "READ_COMPLETED_ALL", {}, expireToken);
  //   const data = await processEncryptedResponse(res);
  //   if (Array.isArray(data)) {
  //     setQAList(data?.filter(Boolean));
  //   }
  // };

  // useEffect(() => {
  //   fetchCompleteCall();
  // }, []);

  return (
    <>
      <>
        <div className="container-fluid">
          {/* <div className="">
            <FilterSection />
          </div> */}
          <DataTable
            updatedColumns={updatedColumns}
            callApiArgs={{
              endpoint: "calls/summary",
              bodyData: {
                action: "READ_COMPLETED_ALL",
                input: {},
              },
              apiMethod: "post",
            }}
            tableConfig={{
              dataMapper: (item, i) => ({
                key: item?.id,
                "Agent name": item?.agent_name || null,
                "Call type": item?.call_type || null,
                "Review date": moment(item?.created_at).format("MMMM Do YYYY") || null,
                "Call duration": item?.duration || null,
                "QA Comments Summary": item?.callObservation || null,
                Action: "View",
                originalItem: item,
              }),
            }}
          />
        </div>
      </>
      <SelectAuditType
        open={isAuditTypeModalOpen}
        handleCancel={() => setIsAuditTypeModalOpen(false)}
        handleSubmit={(temptype) => {
          const width = window.screen.availWidth;
          const height = window.screen.availHeight;

          window.open(
            `/report-pdf?callId=${
              selectedRow.originalItem?.id || selectedRow.key
            }&auditTypeId=${temptype}`,
            "_blank",
            `width=${width},height=${height},left=0,top=0`
          );
        }}
      />
    </>
  );
};

export default CompleteCalls;
